import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { ColorSelector, ColorType } from "@utils/colors";
import { TW_ColorPickerButton, TW_ColorPickerTrigger, TW_ColorSelectorPopoverContent } from "@utils/twClasses";
import { cn } from "@comps/lib/utils";

interface ColorPickerProps {
    color: string;
    onChange: (color: string) => void;
    colorType: ColorType;
    className?: string;
}

export function ColorPicker({ color, onChange, colorType, className }: ColorPickerProps) {

    const [isColorSelectorOpen, setIsColorSelectorOpen] = useState(false);

    const onColorSelected = (color: string) => {
        setIsColorSelectorOpen(false);
        onChange(color);
    }

    return (
        <Popover open={isColorSelectorOpen} onOpenChange={setIsColorSelectorOpen}>
            <PopoverTrigger className={TW_ColorPickerTrigger}>
                <div className={cn(TW_ColorPickerButton, className ? className : "")} style={{ backgroundColor: color }} />
            </PopoverTrigger>
            <PopoverContent className={TW_ColorSelectorPopoverContent}>
                <ColorSelector onColorSelected={onColorSelected} initialColor={color} colorType={colorType}/>
            </PopoverContent>
        </Popover>
    )
}